import { render, staticRenderFns } from "./addDealer.vue?vue&type=template&id=d58da976"
import script from "./addDealer.vue?vue&type=script&lang=js"
export * from "./addDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports